// extracted by mini-css-extract-plugin
export var container = "_iz-1";
export var cornerButtonContainer = "_iz-6";
export var disabled = "_iz-2";
export var dragActive = "_iz-3";
export var fileContainer = "_iz-5";
export var hiddenInput = "_iz-4";
export var widthContainer = "_iz-0";